import React, { createContext, useContext, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { RootState, AppDispatch } from '../store';
import { getAllPermissionByRoleTrigger } from '../slices/permissionSlice';
import { getAuthDetails } from '../utils/helper';

const PermissionContext = createContext<string[]>([]);

export const PermissionProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const dispatch = useDispatch<AppDispatch>();
  const rolePermissions = useSelector((state: RootState) => state.permission.subModuleList);
  const roleId = getAuthDetails().user.roleId;

  useEffect(() => {
    dispatch(getAllPermissionByRoleTrigger(roleId));
  }, [dispatch, roleId]);
  console.log('--------------', roleId);

  const userPermissions = rolePermissions.data?.subModules?.map(
    (item: { roleKey: string }) => item.roleKey,
  ) || [];

  return (
    <PermissionContext.Provider value={userPermissions}>{children}</PermissionContext.Provider>
  );
};

export const usePermissions = () => useContext(PermissionContext);
